import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "c-leadership-team__grid" }
const _hoisted_2 = { class: "c-leadership-team__media" }
const _hoisted_3 = { class: "c-leadership-team__content" }
const _hoisted_4 = { class: "c-leadership-team__info" }

import { computed } from 'vue';
import { RichText, Text as JssText } from '@sitecore-jss/sitecore-jss-vue';
import type {
  LeadershipTeamMemberFields,
  LeadershipTeamProps,
} from '@/types/components/LeadershipTeam';
import type { ScItem } from '@/types/sitecore';
import utils from '@/utils';

interface LeadershipTeamMember extends ScItem<LeadershipTeamMemberFields> {
  fields: LeadershipTeamMemberFields;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LeadershipTeam',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'c-leadership-team'));
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});

const rawMembers = computed<ScItem<LeadershipTeamMemberFields>[]>(() => {
  const memberItems = utils.sc.getFieldObj(fields.value, 'members');
  return Array.isArray(memberItems) ? memberItems : [];
});

const members = computed<LeadershipTeamMember[]>(() =>
  rawMembers.value
    .map((member) => {
      const memberFields = member.fields;
      if (!memberFields) return null;

      return {
        ...member,
        fields: memberFields,
      };
    })
    .filter((member): member is LeadershipTeamMember => Boolean(member))
);

return (_ctx: any,_cache: any) => {
  const _component_AdaptiveImage = _resolveComponent("AdaptiveImage")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value && members.value.length)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value)
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(members.value, (member) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: member.id,
                  class: "c-leadership-team__card"
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    (member.fields.photo)
                      ? (_openBlock(), _createBlock(_component_AdaptiveImage, {
                          key: 0,
                          class: "c-leadership-team__photo",
                          field: member.fields.photo,
                          show: true,
                          "enable-scroll-detection": false,
                          "show-image-redius": false
                        }, null, 8, ["field"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      (member.fields.role?.value)
                        ? (_openBlock(), _createBlock(_unref(JssText), {
                            key: 0,
                            class: "c-leadership-team__role",
                            field: member.fields.role,
                            tag: "h3"
                          }, null, 8, ["field"]))
                        : _createCommentVNode("", true),
                      (member.fields.name?.value)
                        ? (_openBlock(), _createBlock(_unref(JssText), {
                            key: 1,
                            class: "c-leadership-team__name",
                            field: member.fields.name,
                            tag: "p"
                          }, null, 8, ["field"]))
                        : _createCommentVNode("", true)
                    ]),
                    (member.fields.description?.value)
                      ? (_openBlock(), _createBlock(_unref(RichText), {
                          key: 0,
                          class: "c-leadership-team__description",
                          field: member.fields.description
                        }, null, 8, ["field"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ], 6))
    : _createCommentVNode("", true)
}
}

})